import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const PendingApproval = () => {
  const { user, logout, isPendingContributor } = useAuth();

  if (!user) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h2 className="login-title">Sign in required</h2>
          <p className="auth-subtitle">Please sign in to view your application status.</p>
          <Link to="/login" className="btn btn-primary" style={{ display: 'inline-flex' }}>Sign in</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card auth-card-wide">
        <div style={{ textAlign: 'center', marginBottom: '16px' }}>
          <Clock size={48} color="#b45309" />
        </div>
        <h2 className="login-title">Application pending</h2>
        {isPendingContributor ? (
          <>
            <p className="auth-subtitle">
              Thanks, <strong>{user.full_name || user.name || user.username}</strong>. Your contributor profile is waiting for admin review.
            </p>
            <div className="auth-alert auth-alert-info">
              We emailed you a confirmation. Admins were also notified and can approve or reject your application from User Management.
              You can browse the site, but publishing is disabled until approval.
            </div>
          </>
        ) : (
          <p className="auth-subtitle">Your account is active. You can continue to the site.</p>
        )}
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '20px' }}>
          <Link to="/" className="btn btn-primary">Browse site</Link>
          <button type="button" className="btn btn-secondary" onClick={logout}>Sign out</button>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
